<template>
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">{{ pageTitle }}</div>
          <div class="card-body">
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label">メールアドレス</label>
                <input type="email" class="form-control" id="email" v-model="email" required>
              </div>
              <div class="mb-3">
                <label for="password" class="form-label">パスワード</label>
                <input type="password" class="form-control" id="password" v-model="password" required>
              </div>
              <button type="submit" class="btn btn-primary" :disabled="isSsoProcessing">
                {{ isSsoProcessing ? '連携ログイン中...' : 'ログイン' }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { consumeSystemHandoff, login } from '@/api/axios';

// eslint-disable-next-line vue/multi-word-component-names
export default {
  name: "LoginPage", 
  setup() {
    const title = ref('ログイン');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const email = ref('');
    const password = ref('');
    const isSsoProcessing = ref(false);

    const resolveLoginErrorMessage = (error) => {
      const apiData = error?.response?.data;
      const firstError = Array.isArray(apiData?.errors) ? apiData.errors[0] : null;

      if (firstError) return firstError;
      if (typeof apiData?.error === 'string') return apiData.error;
      if (typeof apiData?.message === 'string') return apiData.message;

      return 'ログイン失敗！';
    };

    const completeLoginSession = () => {
      store.dispatch('setLoggedIn', true);
      store.dispatch('setUserName', localStorage.getItem('userName'));
      store.dispatch('setUserRole', localStorage.getItem('userRole'));
    };

    const handleLogin = async () => {
      try {
        await login(email.value, password.value);
        completeLoginSession();
        store.dispatch('setFlashMessage', {message: 'ログイン成功！', type: 'success'});
        router.push('/home');
      } catch (error) {
        const errorMessage = resolveLoginErrorMessage(error);
        store.dispatch('setFlashMessage', {message: errorMessage, type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    const handleSsoLogin = async (handoffToken) => {
      if (!handoffToken) return;

      try {
        isSsoProcessing.value = true;
        await consumeSystemHandoff(handoffToken);
        completeLoginSession();
        store.dispatch('setFlashMessage', {message: 'システム連携ログイン成功！', type: 'success'});
        router.replace('/home');
      } catch (error) {
        const errorMessage = resolveLoginErrorMessage(error);
        store.dispatch('setFlashMessage', {message: errorMessage, type: 'danger'});
        router.replace('/login');
        console.error('システム連携ログインエラー:', error);
      } finally {
        isSsoProcessing.value = false;
      }
    };

    onMounted(async () => {
      const handoffToken = route.query.sso_token;
      if (typeof handoffToken === 'string' && handoffToken.length > 0) {
        await handleSsoLogin(handoffToken);
      }
    });

    return { 
      title,
      email,
      password,
      isSsoProcessing,
      handleLogin,
      pageTitle: 'ログイン' // ページのタイトル
    };
  }
};
</script>
